import {DeleteOutlined, DownloadOutlined, UploadOutlined} from "@ant-design/icons";
import {Popconfirm} from "antd";
import React, {useMemo} from "react";
import {IMediaHubToolbar} from "../type/media-hub.types";

const MediaHubToolbar: React.FC<IMediaHubToolbar> = (props) => {

    const isAllSelected = useMemo(() => {
        return props.files.length > 0 && props.selectedIds.size === props.files.length;
    }, [props.files.length, props.selectedIds]);

    const isButtonEnabled = isAllSelected || props.selectedIds.size > 0;

    function toggleSelectAll() {
        const nextSelected = isAllSelected
            ? new Set<string>()
            : new Set(props.files.map(file => file.id));
        props.setSelectedIds(nextSelected);
    }

    function handleDownloadAll() {
        const ids = Array.from(props.selectedIds);
        if (ids.length) props.handleMultipleDownload(ids);
    }

    function handleDeleteAll() {
        const ids = Array.from(props.selectedIds);
        if (ids.length) props.handleMultipleDelete(ids);
    }

    return (
        <span className={'tool-bar'}>
                        <label htmlFor={'select-all'}>
                            Select All
                            <input
                                name='select-all'
                                type={"checkbox"}
                                id={'select-all'}
                                checked={isAllSelected}
                                onChange={toggleSelectAll}
                            />
                        </label>

                        <div className={'action-panel'}>
                          {props.isAdmin && <button
                              onClick={props.handleMediaUploadOpen}
                              className={'action-panel__Upload'}
                          >
                              <UploadOutlined/>
                              Upload
                          </button>}

                            <button
                                onClick={handleDownloadAll}
                                disabled={!isButtonEnabled}
                                className={'action-panel__Download'}>
                                 <DownloadOutlined/>
                                Download
                            </button>

                            {props.isAdmin &&
                            <Popconfirm
                                title={'Delete the Images'}
                                description={
                                    <p>
                                        Are you sure to delete selected images?
                                    </p>
                                }
                                onConfirm={handleDeleteAll}
                            >
                                <button
                                    className={'action-panel__Delete'}
                                    disabled={!isButtonEnabled}
                                >
                                    <DeleteOutlined/>
                                    Delete

                                </button>
                            </Popconfirm>
                            }
                                </div>
                                </span>
    )
}

export default MediaHubToolbar;